import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getMovieList, getAlltheData } from '../../actions/movielist-actions'
import { appHeightChanged } from '../../actions/app-actions'
import './styles/program.scss'





class Biografer extends React.Component {
   
    constructor() {
        super();
        this.toFindDuplicates = this.toFindDuplicates.bind(this)
        this.BioPerRegion = this.BioPerRegion.bind(this)

    }
    componentDidMount() {
        const { actions, movies, iframeId } = this.props
        if (window.parent != window) actions.appHeightChanged(iframeId, true, false, true);
       
        if (movies.length == 0) {
            actions.getMovieList(3);
            actions.getAlltheData()
        }
       
    }
    

   
    toFindDuplicates() {
        let arr = []
        const { allOrganizers } = this.props
       allOrganizers && allOrganizers.filter((i) => arr.push(i.region))
        const uniqueElements = new Set(arr);
        // const filteredElements =
        arr.filter((item) => {
            if (uniqueElements.has(item)) {
                // uniqueElements.delete(item);
            } else {
                return item;
            }
        });

        return [...new Set(uniqueElements)];
    }

    BioPerRegion(name) {
        const { allOrganizers } = this.props
       // console.log(name)
        let arr = []
        allOrganizers.map((orgs) => {
            if (orgs.region === name) {
              //  console.log(orgs, 'orgs')
                arr.push(orgs)
            }
            return arr
        })
        return arr
    }
    render() {
        const { allOrganizers } = this.props
        const duplicateElements = this.toFindDuplicates()
      
        let orgs = []
        for (let i = 0; i < duplicateElements.length; i++) {
            orgs.push({
                region: duplicateElements[i],
                bios: this.BioPerRegion(duplicateElements[i])
            })
        }
       
        return (
            <> 
                {allOrganizers ? 
                    <div className='biograferContainer'>
                      <p className='bio_title' >Vælg biograf</p>
                        <p className='bio_count'>I alt: {allOrganizers && allOrganizers.length} biografer bruger billetsystem fra ebillet</p>

                        

                <section className='biografer'>
               
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              
 
                    {duplicateElements.sort((a, b) => a > b ? 1 : -1).map((i,index) => {
                        if (i === 'Bornholm' || i === 'Færøerne'  || i === 'Grønland')
                            return <div key={index} style={{marginBottom:'20px'} }>
                                <p className='region_name'>{i}</p>
                                {allOrganizers.map((org,indx) => {
                                    if (org.region === i) {
                                        return <div key={indx} style={{ fontFamily: "PP Neue Montreal", letterSpacing: '0.51px' }}>
                                            <span style={{ height: '10px', fontSize: '17px', color: 'white',}}>{org.city}, {org.name}</span>
                                          
                                           
                                        </div>
                                    }

                                })}
                            </div>
                    
                  else  if (i === 'Fyn' )
                                return <div key={index} style={{ marginBottom: '20px' }}>
                                    <p className='region_name'>{i}</p>
                                    {orgs.map((org, indx) => {
                                        if (org.region === 'Fyn') {
                                            return org.bios.sort((a, b) => a.city > b.city ? 1 : -1).map((bio) => { 
                                            return <div key={indx} style={{ fontFamily: "PP Neue Montreal", letterSpacing: '0.51px' }}>
                                                <span style={{ height: '10px', fontSize: '17px', color: 'white',  }}>{bio.city}, {bio.name}
                                                </span>
                                               


                                                </div>
                                            })
                                        }

                                    })}
                                </div>
                    }

                    )}



                </div>

                <div style={{ color: 'lightgrey', fontSize: '14px' }}>
                    {duplicateElements.sort((a, b) => a > b ? 1 : -1).map((i,index) => {
                        if ( i === 'Jylland' )
                            return <div key={index} style={{ marginBottom: '20px' }}>
                                <p className='region_name'>{i}</p>
                                {orgs.sort((a,b) => a.name > b.name ? 1 : -1).map((org,indx) => {
                                    if (org.region === 'Jylland') {
                                        return org.bios.sort((a, b) => a.city > b.city ? 1 : -1).map((bio) => {
                                            return <div key={indx} style={{  fontFamily: "PP Neue Montreal", letterSpacing: '0.51px' }}>
                                                <span style={{ height: '10px', fontSize: '17px', color: 'white' }}>{bio.city}, { bio.name}</span>
                                              
                                            </div>
                                        })
                                    }

                                })}
                            </div>
                    })}
                            </div>

                <div style={{ color: 'lightgrey', fontSize: '14px' }}>
                                {duplicateElements.sort((a, b) => a > b ? 1 : -1).map((i, index) => {
                                    if (i === 'Lolland Falster'  )
                                        return <div key={index} style={{ marginBottom: '30px' }}>
                                            <p className='region_name' >{i}</p>
                                            {orgs.sort((a, b) => a.name > b.name ? 1 : -1).map((org, indx) => {
                                                if (org.region === 'Lolland Falster') {
                                                    return org.bios.sort((a, b) => a.city > b.city ? 1 : -1).map((bio) => {
                                                        return <div key={indx} style={{ fontFamily: "PP Neue Montreal", letterSpacing: '0.51px' }} >
                                                            <span style={{ height: '10px', fontSize: '17px', color: 'white' }}>{bio.city}, {bio.name}</span>


                                                        </div>
                                                    })
                                                }

                                            })}
                                        </div>
                                    else if (i === 'Samsø')
                                        return <div key={index} style={{ marginBottom: '30px' }}>
                                            <p className='region_name' >{i}</p>
                                            {orgs.sort((a, b) => a.name > b.name ? 1 : -1).map((org, indx) => {
                                                if (org.region === 'Samsø') {
                                                    return org.bios.sort((a, b) => a.city > b.city ? 1 : -1).map((bio) => {
                                                        return <div key={indx} style={{ fontFamily: "PP Neue Montreal", letterSpacing: '0.51px' }} >
                                                            <span style={{ height: '10px', fontSize: '17px', color: 'white' }}>{bio.city}, {bio.name}</span>


                                                        </div>
                                                    })
                                                }

                                            })}
                                        </div>
                                    else if ( i === 'Sjælland')
                                        return <div key={index} style={{ marginBottom: '30px' }}>
                                            <p className='region_name' >{i}</p>
                                            {orgs.sort((a, b) => a.name > b.name ? 1 : -1).map((org, indx) => {
                                                if (org.region === 'Sjælland') {
                                                    return org.bios.sort((a, b) => a.city > b.city ? 1 : -1).map((bio) => {
                                                    return <div key={indx} style={{ fontFamily: "PP Neue Montreal", letterSpacing: '0.51px' }} >
                                                        <span style={{ height: '10px', fontSize: '17px', color: 'white' }}>{bio.city}, { bio.name}</span>
                                                      

                                                        </div>
                                                    })
                                                }

                                            })}
                                        </div>
                                    
                                })}
                            </div>

                <div style={{ color: 'lightgrey', fontSize: '14px' }}>
                {duplicateElements.sort((a, b) => a > b ? 1 : -1).map((i,index) => {
                    if (i === 'Storkøbenhavn')
                        return <div key={index}>
                            <p className='region_name' >{i}</p>
                            {orgs.sort((a, b) => a.name > b.name ? 1 : -1).map((org, indx) => {
                                if (org.region === 'Storkøbenhavn') {
                                    return org.bios.sort((a, b) => a.city > b.city ? 1 : -1).map((bio) => {
                                        return <div key={indx} style={{ fontFamily: "PP Neue Montreal", letterSpacing: '0.51px',  }} >
                                            <span style={{ height: '10px', fontSize: '17px', color: 'white' }}>{bio.city}, {bio.name}</span>


                                        </div>
                                    })
                                }

                            })}
                        </div>
                })}
                </div>
        
                    
                        </section>
                    </div>

           : <div className='spinner'></div>}
           
        </>
    )
    }
}

const mapStateToProps = (state, ownProps) => {
    
    const config = state.organizer.configuration;
    const listConfig = config.movielists;
    const movies = listConfig.date.base ? extractMoviesAsBases(state.movielist.movies) : state.movielist.movies;
    function extractMoviesAsBases(movies) {
        const moviesBases = state.movielist.movieBases;
        const moviesAsBase = [];
        _.each(movies, (movie) => {
            if (movie.baseId) {
                const baseMovie = _.find(moviesBases, (base) => { return base.id == movie.baseId; });
                const alreadyInList = _.some(moviesAsBase, ['baseId', movie.baseId]);
                if (baseMovie && !alreadyInList) moviesAsBase.push({ ...movie, name: baseMovie.name, posters: baseMovie.posters });
            } else moviesAsBase.push(movie);
        });
        return moviesAsBase;
    }

    return {
        movies,
        allMovies: state.movielist.allMovies,
        allEvents: state.movielist.allEvents,
        allLocations: state.movielist.allLocations,
        allMovieBases: state.movielist.allMovieBases,
        allOrganizers: state.movielist.allOrganizers,
        iframeId: state.app.iframeId,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Object.assign({}, { getAlltheData, appHeightChanged, getMovieList }), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Biografer)